import {
  translateVisaMenuToLabels
} from '../components/FilterControl/translateVisaMenuToLabels.fun';
import {
  RELATION__JOBS_STARRED
} from '../dictionaries/Relations.dic';
import {
  join
} from './Array.lib';
import Candidate from "./Candidate";
import Core from "./Core";
import Definition, {
  LOCATION__AMERICAS,
  LOCATION__CALIFORNIA,
  LOCATION__SAN_FRANCISCO_BAY_AREA,
  LOCATION__UNITED_STATES,
  LOC_TYPE__ALIAS_ID,
  LOC_TYPE__CITY_ID,
  LOC_TYPE__COUNTRY_ID,
  LOC_TYPE__METRO_AREA_ID,
  LOC_TYPE__METRO_AREA_SEC_ID,
  LOC_TYPE__MULTI_CONT_ID,
  LOC_TYPE__STATE_ID,
  VISA_CANDIDATE__CITIZEN,
  VISA_CANDIDATE__GREEN_CARD,
  VISA_CANDIDATE__H1B_WITH_I140_APPROVED,
  VISA_CANDIDATE__H4_EAD,
  VISA_CANDIDATE__J1,
  VISA_CANDIDATE__L1,
  VISA_CANDIDATE__NEEDS_H1B1_E3_CH_SN_AU,
  VISA_CANDIDATE__NEEDS_H1B_VISA_TRANSFER,
  VISA_CANDIDATE__NEEDS_NEW_VISA_SPONSOR,
  VISA_CANDIDATE__NEEDS_TN_CN_MX,
  VISA_CANDIDATE__NO_SPONSORSHIP_REQUIRED,
  VISA_CANDIDATE__O1,
  VISA_CANDIDATE__OPT_CPT_F1,
  VISA_CANDIDATE__VISA_STATUS_UNKNOWN,
  VISA__CITIZEN_AND_GREEN_CARD_ONLY,
  VISA__CITIZEN_ONLY,
  VISA__VISA_SUPPORT_UNKNOWN,
  VISA__WILL_SPONSOR_NEW_H1,
  VISA__WILL_TRANSFER_H1
} from "./Definition";
import LocationLib from "./DefinitionLocation.lib";
import Engagement from "./Engagement";
import {
  getShortURL
} from "./GenericTools.lib";
import Http from "./Http";
import {
  Obj
} from './Object.lib';
import Streak from './Streak';
import {
  trim
} from './String.lib';
import {
  model as jobModel,
  mapJob,
  mapJobs
} from "./models/job";
import updateStarred from './models/updateStarred.fun';
import {
  COLLECTION__JOBS
} from './services/BE/loopback.api';
import cleanHtml from "./tools/cleanHtml";
import formatURL from "./tools/formatURL";
import getStateModel from "./tools/getStateModel";

const cache = {};

const commonQuery = (opts = {}) => {
  let includeArray = [
    {
      relation: "employer",
      scope: {
        include: ["employerBlackList", "employerSourceList"],
      },
    },
    "resumeSubmissionEmailTemplate",
    "jobBlackList",
    "jobSourceList",
    {
      relation: RELATION__JOBS_STARRED,
      scope: {
        where: { accountId: Core.getUserId() },
        limit: 1
      },
    },
  ];

  if (opts.engagements) {
    includeArray.push({
      relation: "engagements",
      scope: {
        where: {
          rejectionReason: { nin: ["10x10 - No Match", "bad_match"] },
        },
        fields: [
          "state",
          "stage",
          "status",
          "id",
          "rejectionReason",
          "feedback",
          "submitted",
        ],
      },
    });
  }

  if (typeof opts.include === "boolean" && !opts.include) {
    includeArray = [];
  }
  return { include: includeArray };
};

const menus = [

  // Roles(dj)
  { label: "Roles", key: "roles", field: "_rolesKeys", multiple: true },

  //  { label: "Level", key: "level", field: "_level" },

  // Technology(dj)
  {
    label: "Technology",
    key: "technicalSkills",
    field: "_technicalSkillsKeys",
    multiple: true,
  },

  // Visa(h)
  {
    label: "Visa",
    key: "visa",
    // inputType: "radio",
    field: "_visaTransfer",
    options: {
      [VISA_CANDIDATE__CITIZEN]: false,
      [VISA_CANDIDATE__GREEN_CARD]: false,
      [VISA_CANDIDATE__NEEDS_TN_CN_MX]: false,
      [VISA_CANDIDATE__NEEDS_H1B1_E3_CH_SN_AU]: false,
      [VISA_CANDIDATE__NEEDS_H1B_VISA_TRANSFER]: false,
      [VISA_CANDIDATE__NEEDS_NEW_VISA_SPONSOR]: false,
      [VISA_CANDIDATE__OPT_CPT_F1]: false,
      [VISA_CANDIDATE__H1B_WITH_I140_APPROVED]: false,
      [VISA_CANDIDATE__L1]: false,
      [VISA_CANDIDATE__H4_EAD]: false,
      [VISA_CANDIDATE__J1]: false,
      [VISA_CANDIDATE__O1]: false,
      [VISA_CANDIDATE__VISA_STATUS_UNKNOWN]: false,
      [VISA_CANDIDATE__NO_SPONSORSHIP_REQUIRED]: false,
    },
    mappings: {
      [VISA_CANDIDATE__CITIZEN]: [
        VISA__CITIZEN_ONLY,
        VISA__CITIZEN_AND_GREEN_CARD_ONLY,
        VISA__WILL_TRANSFER_H1,
        VISA__WILL_SPONSOR_NEW_H1,
        VISA__VISA_SUPPORT_UNKNOWN,
      ],
      [VISA_CANDIDATE__GREEN_CARD]: [
        VISA__CITIZEN_AND_GREEN_CARD_ONLY,
        VISA__WILL_TRANSFER_H1,
        VISA__WILL_SPONSOR_NEW_H1,
        VISA__VISA_SUPPORT_UNKNOWN,
      ],
      [VISA_CANDIDATE__NEEDS_TN_CN_MX]: [
        VISA__WILL_TRANSFER_H1,
        VISA__WILL_SPONSOR_NEW_H1,
        VISA__VISA_SUPPORT_UNKNOWN,
      ],
      [VISA_CANDIDATE__NEEDS_H1B1_E3_CH_SN_AU]: [
        VISA__WILL_TRANSFER_H1,
        VISA__WILL_SPONSOR_NEW_H1,
        VISA__VISA_SUPPORT_UNKNOWN,
      ],
      [VISA_CANDIDATE__NEEDS_H1B_VISA_TRANSFER]: [
        VISA__WILL_TRANSFER_H1,
        VISA__WILL_SPONSOR_NEW_H1,
        VISA__VISA_SUPPORT_UNKNOWN,
      ],
      [VISA_CANDIDATE__NEEDS_NEW_VISA_SPONSOR]: [
        VISA__WILL_SPONSOR_NEW_H1,
        VISA__VISA_SUPPORT_UNKNOWN
      ],
      [VISA_CANDIDATE__OPT_CPT_F1]: [
        VISA__WILL_TRANSFER_H1,
        VISA__WILL_SPONSOR_NEW_H1,
        VISA__VISA_SUPPORT_UNKNOWN,
      ],
      [VISA_CANDIDATE__H1B_WITH_I140_APPROVED]: [
        VISA__WILL_TRANSFER_H1,
        VISA__WILL_SPONSOR_NEW_H1,
        VISA__VISA_SUPPORT_UNKNOWN,
      ],
      [VISA_CANDIDATE__L1]: [
        VISA__WILL_SPONSOR_NEW_H1,
        VISA__VISA_SUPPORT_UNKNOWN
      ],
      [VISA_CANDIDATE__H4_EAD]: [
        VISA__WILL_SPONSOR_NEW_H1,
        VISA__VISA_SUPPORT_UNKNOWN
      ],
      [VISA_CANDIDATE__J1]: [
        VISA__WILL_SPONSOR_NEW_H1,
        VISA__VISA_SUPPORT_UNKNOWN
      ],
      [VISA_CANDIDATE__O1]: [
        VISA__WILL_SPONSOR_NEW_H1,
        VISA__VISA_SUPPORT_UNKNOWN
      ],
      [VISA_CANDIDATE__NO_SPONSORSHIP_REQUIRED]: [
        VISA__CITIZEN_AND_GREEN_CARD_ONLY,
        VISA__WILL_TRANSFER_H1,
        VISA__WILL_SPONSOR_NEW_H1,
        VISA__VISA_SUPPORT_UNKNOWN,
      ],
      [VISA_CANDIDATE__VISA_STATUS_UNKNOWN]: [
        VISA__CITIZEN_ONLY,
        VISA__CITIZEN_AND_GREEN_CARD_ONLY,
        VISA__WILL_TRANSFER_H1,
        VISA__WILL_SPONSOR_NEW_H1,
        VISA__VISA_SUPPORT_UNKNOWN,
      ],
    },
  },

  /* epic-3038-story-3083 - 2021-06-17 µ */
  /* epic-3038-story3330-m2 - 2021-07-01 µ */
  // Remote Options(s-mc)
  {
    label: "Remote Options",
    key: "inOfficeRemoteFlags",
    definitionKey: "inOfficeRemote",
    field: "_inOfficeRemoteFlagsKeys",
    prefix: "Remote",
    /* epic-3038-story3330-m5 - 2021-07-02 µ */
    multiple: true,
  },

  /** This is needed for filtering results story-3083 2021-06-17 µ */
  // WFH Locations(s-mc)
  {
    label: "WFH Locations",
    key: "candidateLocations",
    definitionKey: "location",
    field: "_candidateLocationsKeys",
    multiple: true,
    prefix: "WFH",
    listingPages: {
      layers: [
        LOC_TYPE__ALIAS_ID,
        LOC_TYPE__MULTI_CONT_ID,
        LOC_TYPE__COUNTRY_ID,
        LOC_TYPE__STATE_ID,
        LOC_TYPE__METRO_AREA_ID,
        LOC_TYPE__METRO_AREA_SEC_ID,
      ],
      treeDefaultExpandedIds: [
        LOCATION__AMERICAS,
        LOCATION__UNITED_STATES,
        LOCATION__CALIFORNIA,
        LOCATION__SAN_FRANCISCO_BAY_AREA
      ]
    },
    matchingPages: {
      layers: [
        LOC_TYPE__ALIAS_ID,
        LOC_TYPE__MULTI_CONT_ID,
        LOC_TYPE__COUNTRY_ID,
        LOC_TYPE__STATE_ID,
        LOC_TYPE__METRO_AREA_ID,
        LOC_TYPE__METRO_AREA_SEC_ID,
        LOC_TYPE__CITY_ID,
      ],
      treeDefaultExpandedIds: [
        LOCATION__AMERICAS,
        LOCATION__UNITED_STATES,
        LOCATION__CALIFORNIA,
        LOCATION__SAN_FRANCISCO_BAY_AREA,
      ]
    },
  },

  /** This is needed for filtering results story-3083 2021-06-17 µ */
  // Office Locations(s-mc)
  {
    label: "Office Locations",
    key: "officeLocations",
    definitionKey: "location",
    field: "_officeLocationsKeys",
    multiple: true,
    prefix: "Office",
  },

  // Stage(h)
  {
    label: "Stage",
    key: "stage",
    field: "_stage",
    options: {
      "Late Stage Startup": false,
      Public: false,
      Seed: false,
      "Series A": false,
      "Series B": false,
      "Series C": false,
      "Series D+": false,
    },
    mappings: {
      "Late Stage Startup": ["Unknown", "Late Stage Startup"],
      Public: ["Unknown", "Public"],
      Seed: ["Unknown", "Seed"],
      "Series A": ["Unknown", "Series A"],
      "Series B": ["Unknown", "Series B"],
      "Series C": ["Unknown", "Series C"],
      "Series D+": ["Unknown", "Series D+"],
    },
  },
];

let more = Core.isAdminOrCoordinator()
  ? [

    //State(dj)
    { label: "State", key: "state" },

    /* commented by AC request | 2021-07-08 µ */
    // { label: "Work From Home", key: "remote" },

    /* epic-3038(new locations)-story-3083-M1-1 2021-06-17 µ */
    /* epic-3038(new locations)-story-3652-m4 | 2021-08-03 Tue µ */
    /** * /
    // Job Type(dj)
    {
      label: "Job Type",
      key: "jobType",
      field: "_jobType",
      visible: true, // set to false if April no agree to show it.
    },
    /** */

    /* epic-3038(new locations)-story-3652-m4 | 2021-08-03 Tue µ */
    {
      label: "Job Type",
      key: "desiredEmploymentType",
      field: "_desiredEmploymentTypes",
      visible: true, // set to false if April no agree to show it.
      multiple: true,
    }

  ]
  : [

    /* commented by AC request | 2021-07-08 µ */
    // { label: "Work From Home", key: "remote" }

  ];

/** @todo review following commented line. to cleanup? ask to BobB | 2021-08-03 Tue µ */
// more.push({label: "Desired Stage", key: "stage"});

let listTabs = ["My Sourcing", "Role", "Recent", "Employer", "Starred"];

const listTab = "Role";

/** HARDCODED FOR LOCAL DEBUG PURPOSES */
/** */
const DEBUG_MATCH_DETAILS = Core.debug('DEBUG_MATCH_DETAILS') && {
  "match": {
    "match": "xx",
    "score": 57.33,
    "score_must_haves": 33.33333333333333,
    "without_not_operator_truthies_divide_by_total_must": 0.6666666666666666,
    "with_not_operator_weightage_to_subtract_must": 0,
    "score_nice_haves": 4.0,
    "without_not_operator_truthies_divide_by_total_nice": 0.4,
    "with_not_operator_weightage_to_subtract_nice": 0,
    "score_platform_rating": 20.0
  }
};
/** */

const Job = {
  name: 'Job',
  more,
  listTabs,
  listTab,
  columns: [
    {
      headers: [
        { label: "Employer", key: "_employerName", order: 13, collapsed: true },
        {
          label: "Engagements",
          key: "_engagementsInfoCmp",
          sortKey: "_engagementsLength",
          hint: false,
          reverseSort: true,
          order: 9,
          collapsed: true,
        },
      ],
      selected: 0,
      span: 2,
      style: { minWidth: 256 },
    },
    {
      headers: [
        {
          label: "Job Title",
          key: "_jobTitleCmp",
          sortKey: "jobTitle",
          order: 3,
          collapsed: true,
        },
        {
          label: "Technical Skills",
          key: "_technicalSkills",
          multiple: true,
          order: 4,
          collapsed: true,
        },
      ],
      selected: 0,
      span: 2,
    },
    {
      headers: [
        { label: "Visa", key: "_visaTransfer", order: 7, collapsed: false },
        {
          label: "Years of Experience",
          key: "_yearsOfExperience",
          sortKey: "minYearsOfExperience",
          order: 6,
          collapsed: false,
        },
      ],
      selected: 0,
      span: 2,
    },
    {
      headers: [
        { label: "Role", key: "_role", order: 2, collapsed: false },
        { label: "City", key: "addressCity", order: 9, collapsed: true },
      ],
      selected: 0,
      span: 3,
    },
    {
      headers: [
        {
          label: "Employees",
          key: "_employeeCount",
          sortKey: "_employeeCountNum",
          filter: true,
          collapsed: true,
          order: 11,
        },
        {
          label: "Flags",
          key: "_flags",
          multiple: true,
          order: 14,
          collapsed: true,
        },
      ],
      selected: 0,
      span: 2,
    },
    {
      headers: [
        {
          label: "Starred",
          key: "_rowOptionsCmp",
          sortKey: "_starred",
          reverseSort: true,
          hint: false,
          filter: false,
          collapsed: true,
        },
        {
          label: "State",
          key: "_state",
          visible: false,
          order: 1,
          collapsed: true,
          admin: true,
        },
        {
          label: "Level",
          key: "_level",
          visible: false,
          order: 5,
          collapsed: true,
        },
        {
          label: "Location",
          key: "_location",
          visible: false,
          order: 8,
          collapsed: false,
        },
        {
          label: "Min Salary",
          key: "_minSalary",
          sortKey: "salaryMin",
          visible: false,
          order: 10,
          collapsed: true,
        },
        {
          label: "Company Stage",
          key: "_employeeStage",
          visible: false,
          order: 12,
          collapsed: true,
        },
        {
          label: "Company Rating",
          key: "_employeeRating",
          visible: false,
          order: 15,
          collapsed: true,
        },
      ],
      selected: 0,
      style: { width: 124, textAlign: "right" },
    },
  ],
  cleanCache: (em) =>
    Object.keys(cache).forEach((key) => {
      delete cache[key];
    }),

  getActiveStateIdFromDef: () => {
    return Definition.get("state")
      .filter((obj) => /active/i.test(obj.label))
      .find((o) => o.id);
  },
  getActives: (success, opts = {}) => {
    success = success instanceof Function ? success : function () { };
    if (cache.actives) {
      setTimeout((st) => success(cache.actives));
      return cache.actives;
    } else {
      return Http.get(
        Core.getApi("Jobs"),
        {
          filter: JSON.stringify({
            ...commonQuery(opts.commonQuery),
            where: { state: 1 },
            fields: opts.fields || [],
          }),
        },
        function onSuccess(response) {
          cache.actives = mapJobs(response);
          success(cache.actives);
          return response;
        }
      ).then(mapJobs);
    }
  },
  getAll: (success, filters = {}, opts = {}) => {
    success = success instanceof Function ? success : function () { };
    const key = JSON.stringify(filters).replace(/\W/g, "");

    if (cache[key]) {
      setTimeout((st) => success(cache[key]));
    } else {
      Http.get(
        Core.getApi("Jobs"),
        {
          filter: JSON.stringify({
            ...filters,
            ...commonQuery(opts.commonQuery),
          }),
        },
        function onSuccess(response) {
          cache[key] = mapJobs(response);
          success(cache[key]);
        },
        function onFailure(failure) {
          Core.failure({
            title: <div className="text-capitalize">Sorry Something Went Wrong<br />Fetching Jobs<br />Try again later</div>,
            message: failure,
            exception: failure
          });
          success([]);
        }
      );
    }
  },

  getBlackList: (id, success) => {
    success = success instanceof Function ? success : function () { };
    if (Core.isAdminOrCoordinator()) {
      if (cache.blackList) {
        setTimeout((st) => success(cache.blackList));
      } else {
        Http.get(
          Core.getApi(`Jobs/${id}/jobBlackList`),
          function onSuccess(response) {
            cache.blackList = response;
            success(cache.blackList);
          }
        );
      }
    } else {
      success([]);
    }
  },
  getWhere: (where, success, opts = {}) => {
    let commonQueryParams = [];
    if (opts.overRideCommonQuery) {
      commonQueryParams = opts.overRideCommonQuery;
    } else if (!!opts.include) {
      commonQueryParams = {
        include: [...opts.include],
      };
    } else {
      commonQueryParams = commonQuery(opts.commonQuery);
    }
    success = success instanceof Function ? success : function () { };
    const key = JSON.stringify(where).replace(/\W/g, "");
    return Http.get(
      Core.getApi("Jobs"),
      {
        filter: JSON.stringify({
          ...commonQueryParams,
          where: { ...where },
          fields: Object(opts.fields),
        }),
      },
      function onSuccess(response) {
        cache[key] = mapJobs(response);
        success(cache[key]);
      }
    ).then(mapJobs);
  },

  getMlMatchingScoreBulkCandoMatch: async (
    opts,
    success = (response) => response,
    failure = () => null
  ) => {

    /** HARDCODED FOR LOCAL DEBUG PURPOSES */
    /** */
    if (DEBUG_MATCH_DETAILS) {
      console.debug('getMlMatchingScoreBulkCandoMatch', opts);
      if (opts.apiMethod === "get_candos_scores") {
        return success([{
          ...DEBUG_MATCH_DETAILS,
          item_id: join(opts.params.candoIds)
        }]);
      }
      else {
        return success([{
          ...DEBUG_MATCH_DETAILS,
          item_id: join(opts.params.jobIds)
        }]);
      }
    }
    /** */

    const baseUrl = trim(process.env.REACT_APP_FMS_API_URL);

    if (
      (Core.isLocalHost() || Core.isDevelopment()) &&
      /**
       * @note
       * Following line is in case for whatever reason we can not get the api url from environment variables.
       */
      !baseUrl
    ) {
      return failure(
        'ML service requires REACT_APP_FMS_API_URL for localhost and dev environments'
      );
    }

    const { params, apiMethod } = opts;
    const { candidateId, jobId } = params;

    let queryParams = join([
      '?candidate_id=', candidateId,
    ], '');

    let data = {};

    if (apiMethod === "get_candos_scores") {
      queryParams = join([
        '?job_id=', jobId,
      ], '');
      data = {
        access_token: Core.getAccessToken(),
        cando_ids: params.candoIds.join(","),
        current_ml_model: params.currentMlModel,
        api_url: Core.getApi()
      };
    }
    else {
      data = {
        access_token: Core.getAccessToken(),
        job_ids: params.jobIds.join(","),
        current_ml_model: params.currentMlModel,
        api_url: Core.getApi()
      };
    }

    let finalUrl = `${baseUrl}/${apiMethod}/${queryParams}`;

    return Http.post(
      finalUrl,
      data
    ).then((response) => {
      success(response);
      return response;
    }).catch(failure);
  },

  getMlMatchingScore: (opts, success, failure = () => null) => {

    /**
     * The ML interface this routine uses has been deprecated with the introduction of the
     * different ML models.  We therefore need to avoid using it.  It should be replaced by
     * calling the bulk routine above which utilizes the new interface.
     * ToDo: update all calls to this routine to use the bulk routine
     * 
     */
    console.log('getMlMatchingScore uses deprecated interface', opts);
    console.debug('getMlMatchingScore - returning score = 0');

    const result = {
      match: {
        "match": "xx",
        "score": 0,
        "score_must_haves": 0,
        "without_not_operator_truthies_divide_by_total_must": 0,
        "with_not_operator_weightage_to_subtract_must": 0,
        "score_nice_haves": 0,
        "without_not_operator_truthies_divide_by_total_nice": true,
        "with_not_operator_weightage_to_subtract_nice": 0,
        "score_platform_rating": 0
      }
    };
    success(result);

    /** the rest of this routine is commmented out
     *  Todo: remove this code during clean up
    


    if (DEBUG_MATCH_DETAILS) {
      console.debug('getMlMatchingScore', opts);
      return success({
        ...DEBUG_MATCH_DETAILS,
        "item_id": opts.params.jobId
      });
    }

    if (Core.isDevelopment()) { return failure('ML service is disabled for development environments'); }
    if (Core.isLocalHost() && !(process.env.REACT_APP_FMS_API_URL)) {
      return failure('ML service requires REACT_APP_FMS_API_URL for localhost environments');
    }
    const { jobId, candidateId } = opts.params;
    const baseUrl = trim(process.env.REACT_APP_FMS_API_URL);

    let queryParams = `?candidate_id=${candidateId}&job_id=${jobId}&apiToken=${Core.getAccessToken()}`;

    success = success instanceof Function ? success : function () { };
    failure = success instanceof Function ? success : function () { };

    // const key = JSON.stringify(where).replace(/\W/g, "");
    let finalUrl = `${baseUrl}${queryParams}`;
    Http.get(
      finalUrl,
      function onSuccess(response) {
        success(response);
      },
      function onFailure(result) {
        failure(result);
      }
    );
    */
  },

  get: async (jobId, success, queryOptions) => {
    success = success instanceof Function ? success : function () { };
    queryOptions = Obj(queryOptions || {
      include: [
        {
          relation: 'employer',
          scope: {
            include: ['employerBlackList', 'employerSourceList'],
          },
        },
        { engagements: 'candidate' },
        'resumeSubmissionEmailTemplate',
        'jobBlackList',
        'jobSourceList'
      ],
    });
    if (cache[jobId]) {
      setTimeout((st) => success(cache[jobId]));
      return cache[jobId];
    } else {
      return Http.get(
        Core.getApi(`Jobs/${jobId}`),
        { filter: JSON.stringify(queryOptions) },
        function onSuccess(response) {
          cache[jobId] = mapJob(response);
          success(cache[jobId]);
          return cache[jobId];
        }
      ).then(mapJob);
    }
  },
  post: (job, success) => {
    Job.cleanCache();
    Engagement.cleanCache();
    Candidate.cleanCache();
    Http.post(Core.getApi("Jobs"), mapJobBack({ job }), success);
  },
  update: (jobId, job, success) => {
    Job.cleanCache();
    Engagement.cleanCache();
    Candidate.cleanCache();
    return Http.patch(
      Core.getApi("Jobs/" + jobId),
      mapJobBack({ job }),
      (response) => {
        delete cache[jobId];
        success instanceof Function && success(response);
      }
    );
  },
  updateStarred: (jobId, starredId, starred, success) => updateStarred({
    entityId: jobId,
    collection: COLLECTION__JOBS,
    starred,
  }).then(success),
  updateLocal: (jobId, job) => {
    cache[jobId] = { ...cache[jobId], ...job };
  },
  delete: (jobId, success) => {
    Job.cleanCache();
    Engagement.cleanCache();
    Candidate.cleanCache();
    // Http.delete(Core.getApi("Jobs/" + jobId), success);
    Engagement.getWhere({ jobId }, (response) => {
      // Core.log({ response });
      Http.delete(Core.getApi("Jobs/" + jobId), success);
      const next = (em) => {
        setTimeout((st) => {
          if (!!response.length) {
            const eng = response.pop();
            // Core.log({ eng });
            Http.delete(Core.getApi("Engagements/" + eng.id), (response) => {
              eng.boxKey && Streak.deleteBox({ boxKey: eng.boxKey });
            });
            next();
          }
        });
      };
      next();
    });
  },
  /**
   * Returns a summary info from job
   * 
   * @param {object} job 
   * @param {string} type large | short
   * @returns {string}
   */
  getPreview: (job, type = "large") => {

    const isLarge = type === 'large';
    const isShort = type === 'short';

    const { employer = {} } = job;

    console.debug('job', job);

    if (!employer.id) {
      console.warn('error__get_preview__no_employer_id');
      return '';
    }

    function getLink(link, name) {
      return `<a href="${formatURL(link)}" target="_blank" referrer="noreferrer" class="text-lowercase">${name || link}</a>`;
    }
    function removeHeadings(plainHtmlText = '') {
      return plainHtmlText
        .replace(/<strong>|<\/strong>|<b>|<\/b>|<h(1|2|3|4|5|6)>|<\/h(1|2|3|4|5|6)>|&nbsp;/gi, ' ')
        .replace(/\s{1,2}/gi, ' ')
        .trim();
    }

    const employerName = employer.name?.trim();
    const employerStreet = employer.addressStreet?.trim();
    const employerCity = employer.addressCity?.trim();
    const employerState = employer.addressState?.trim();
    const employerZip = employer.addressZip?.trim();
    const employerURL = employer.url?.trim();
    const employerStage = Definition.getLabel('stage', employer.stage);
    const additionalLocations = LocationLib.getLocationsString({ locations: job.officeLocations });
    const additionalUrls = [employer.crunchbaseUrl, ...employer.additionalUrl.split(/↵|\n|\r\n|,/)]
      .filter((i) => !!i.trim())
      .map((url) => getLink(url));
    const positionOverview = (
      isShort
        ? !!job.jobDescriptionPublicURL
          ? (`<p><a href="${job.jobDescriptionPublicURL}" target="_blank">${job.jobDescriptionPublicURL}</a></p>`)
          : ''
        : !!job.jobDescription.trim().length
          ? (
            `<p>POSITION OVERVIEW</p>${removeHeadings(job.jobDescription)}`
          )
          : ''
    );

    const address = [
      isLarge && employerStreet,
      employerCity,
      employerState,
      isLarge && employerZip
    ].filter(v => !!v && String(v).trim()).join(', ');

    let template = cleanHtml(`
      ${job.jobTitle ? `` : ''}
      <p class="text-capitalize f-bold">
        ${employerName}${job.jobTitle.trim() ? ` - ${job.jobTitle.trim()}` : ''}${employerURL ? ` (${getLink(employerURL, getShortURL(employerURL))})` : ''}
      </p>
      <p>
        SUMMARY
        ${employerStage ? `<br/>Company Stage: ${employerStage} ${employer.totalFunding}` : ''}
        ${employer._technicalSkills ? `<br/>Employer Tech Stack: ${employer._technicalSkills}` : ''}
        ${job._technicalSkills ? `<br/>Acceptable Tech Background: ${job._agnosticTechnicalSkillsJobCopy}` : ''}
        ${employer.employeeCount ? `<br/>Company Size: ~${employer.employeeCount}` : ''}
        ${employer.teamCount ? `<br/>Engineering Team Size: ~${employer.teamCount}` : ''}
        ${address ? `<br/>Address: ${address}` : ''}
      </p>
      ${additionalLocations ? `<p>Additional locations:<br/>${additionalLocations.replace(/, /g, '<br/>')}</p>` : ''}
      ${additionalUrls.length ? `<p>Additional:<br/>${additionalUrls.join('<br/>')}</p>` : ''}
      ${employer.tagline?.trim() ? `<p>QUICK PITCH</p>${removeHeadings(employer.tagline)}` : ''}
      ${employer.product?.trim() ? `<p>COMPANY OVERVIEW</p>${removeHeadings(employer.product)}` : ''}
      ${positionOverview}
    `);

    if (isShort && !!job.jobDescriptionPublicURL) {
      template = cleanHtml(positionOverview);
    }

    return template;

  },
  getMenus() {
    return menus.map((menu) => translateVisaMenuToLabels(menu, 'Job'))
  },
  getMenu({ key }) {
    return translateVisaMenuToLabels(menus.find(n => n.key === key), 'Job');
  }
};

// Object.defineProperty(Candidate, 'menus', {
//   get() {
//     return menus.map((menu) => translateVisaMenuToLabels(menu, 'Job'));
//   },
//   enumerable: true,
// });

export default Job;

export function mapJobBack({ job }) {
  let update = getStateModel(job, jobModel);
  let { emailsList = [] } = job;
  if (!emailsList.length) {
    update.resumeSubmissionEmail1 = '';
    update.resumeSubmissionName1 = '';
    update.resumeSubmissionEmailAction1 = '';
    update.resumeSubmissionEmail2 = '';
    update.resumeSubmissionName2 = '';
    update.resumeSubmissionEmailAction2 = '';
    update.resumeSubmissionEmail3 = '';
    update.resumeSubmissionName3 = '';
    update.resumeSubmissionEmailAction3 = '';
    update.resumeSubmissionEmail4 = '';
    update.resumeSubmissionName4 = '';
    update.resumeSubmissionEmailAction4 = '';
  }
  return update;
}

export async function getJob(options) {
  let { where, fields, limit, order } = options;
  where = Object(where);
  return Http.get(
    Core.getApi('Jobs'),
    {
      filter: JSON.stringify({ where, fields, limit, order })
    }
  );
}

/**
 *
 * @param {object} options
 * @param {string} options.jobId
 * @param {object} options.context
 * @param {string} options.context.ACTION
 *   [plaintext][required][option: ACTION_TYPE__ACCEPT | ACTION_TYPE__REJECT,...]
 * @param {string} options.context.SOURCE
 *   [plaintext][required][option: ACTION_SOURCE__PENDING | ACTION_SOURCE__ATS,...]
 * @param {string} options.context.CANDIDATE_NAME  [plaintext][required]
 * @param {string} options.context.USER  [plaintext][required]
 * @param {string} options.context.PRESETS  [plaintext][optional]
 * @param {string} options.context.NOTE  [plaintext][optional]
 * @param {string} options.stage
 * @returns {promise} results  [object:job]
 */
export async function prependJobFeedbackLog(options) {
  return Http.post(Core.getApi('Jobs/prependFeedbackLog'), options);
}
